import React from 'react'
import { ContentDownload } from '@fs/zion-icon'
import { BillboardButton, Row, Separator } from '@fs/zion-ui'

import Highlight from './SurnameHighlight'
import catalogo from '../../images/catalogo-page.webp'

export default function CatalogoViewer({ catalogoData, showSaveButton = false }) {
  const { url, page } = catalogoData || {}
  const image = catalogoData
    ? {
        src: url,
        alt: `Catálogo image ${page}`,
      }
    : {
        src: catalogo,
        alt: 'An image of the cover page of the catálogo',
      }

  return (
    <>
      <div data-testid="catalogo-viewer" style={{ position: 'relative' }}>
        <img src={image.src} alt={image.alt} style={{ width: '100%', objectFit: 'contain' }} />
        <Highlight {...catalogoData} />
      </div>
      {showSaveButton && (
        <>
          <Separator size="sm" />
          <Row alignX="center">
            {/* download image button */}
            {catalogoData && (
              <BillboardButton
                onClick={() => globalThis.open(image.src, '_blank')}
                emphasis="medium"
                Icon={ContentDownload}
                linkName="Button:Save Catálogo Image:Click"
              >
                Save Catálogo Image
              </BillboardButton>
            )}
          </Row>
        </>
      )}
    </>
  )
}
